import { render, staticRenderFns } from "./ContentTwoColumns.vue?vue&type=template&id=10e049a7&"
import script from "./ContentTwoColumns.vue?vue&type=script&lang=ts&"
export * from "./ContentTwoColumns.vue?vue&type=script&lang=ts&"
import style0 from "./ContentTwoColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockWrapper: require('/tmp/build_1fde6b87/src/components/block/BlockWrapper.vue').default})
